// 简历审核列表
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- search start -->
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">人员/手机号</div>
          <el-input size="mini" class="ipt-sty" v-model="page.keyword" placeholder="人员或手机号搜索" filterable>
          </el-input>
        </el-col>
        <!-- <el-col :span="6">
          <div class="search-area-div">审核状态</div>
          <el-select size="mini" class="ipt-sty" v-model="page.approveState" placeholder="请选择" filterable>
            <el-option v-for="item in approveStateOp" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col> -->
        <el-col :span="6">
          <div class="search-area-div">简历来源</div>
          <el-select size="mini" class="ipt-sty" v-model="page.sourceType" placeholder="请选择" filterable>
            <el-option
              v-for="item in getCodeListByKey('简历来源')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">同步花名册</div>
          <el-select size="mini" class="ipt-sty" v-model="page.isSyncRoster" placeholder="请选择" filterable>
            <el-option v-for="item in syncRosterOp" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getList(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24"  v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">提交时间</div>
          <el-date-picker
            size="mini"
            v-model="updateTime"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审核时间</div>
          <el-date-picker
            size="mini"
            v-model="approveTime"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>

        <el-col :span="6">
          <div class="search-area-div">备案公司</div>
          <el-select
            size="mini"
            @change="handleChangeCompany"
            v-model="page.tenantGuid"
            placeholder="请选择"
            class="ipt-sty"
            clearable
            filterable
          >
            <el-option
              v-for="item in tenantGuidOption"
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="6">
          <div class="search-area-div">备案部门</div>
          <el-select
            size="mini"
            v-model="page.organisationGuid"
            placeholder="请选择"
            class="ipt-sty"
            clearable
            filterable
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in organisationList"
              :key="item.guid"
              :label="item.organisationName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="24"  v-show="showMore">
        <el-col :span="6">
            <div class="search-area-div">业务员能力</div>
            <el-select
              size="mini"
              v-model="page.staffLevelList"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
              multiple
            >
              <el-option
                v-for="item in getCodeListByKey('业务员能力分类')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
      </el-row>

    </div>
    <!-- search end -->

    <!-- table start -->
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px'">
      <!-- <el-tabs v-model="page.approveState" type="card" @tab-click="changeTab">
        <el-tab-pane v-for="(item, index) in tabText"  :label="item.name" :name="item.value"></el-tab-pane>

      </el-tabs> -->
      <div class="searchHead">
        <div class="searchHead-left">
          <div
            v-for="(item, index) in tabText"
            :key="index"
            :class="activeTab == index ? 'tab active' : 'tab'"
            @click="changeTab(index, item)"
          >
            <div>{{ item.name }}</div>
            <div class="line"></div>
          </div>
        </div>
        <div class="button-area">
          <el-button v-if="page.approveState=='A'" size="mini" type="info" @click="batchAudit('',false)">批量审核</el-button>
          <el-button v-if="page.approveState=='Y'||page.approveState=='R'" size="mini" @click="revokeAudit()">批量撤回重审</el-button>
          <el-button size="mini" type="info" @click="batchImport">批量导入</el-button>
          <el-button size="mini" type="info" @click="batchExport" v-loading.fullscreen.lock="fullscreenLoading"
            >批量导出</el-button>
        </div>
      </div>
      <el-table
       :height="tableHeight" 
       ref="multipleTable"
       :data="tableData" 
       stripe 
       border 
       style="width: 100%" 
       :row-key="(row) => row.guid"
       @selection-change="handleSelectionChange"
       v-loading="tableLoading">
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="40"
          fixed="left"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="templateName"
          label="人员姓名"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="70"
        >
          <template slot-scope="scope">{{ scope.row.name || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="联系方式"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="110"
        >
          <template slot-scope="scope">{{ scope.row.mobileNo || '-' }}</template>
        </el-table-column>
        <el-table-column width="160" prop="updateTime" label="首次提交时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column width="160" prop="approveTime" label="审核时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.approveTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="简历来源"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="130"
        >
          <template slot-scope="scope">{{ getName(scope.row.sourceType, '简历来源') }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          width="96"
          label="审核状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.approveState" :type="type[scope.row.approveState]">{{
              approveStateObj[scope.row.approveState] || '-'
            }}</el-tag>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="邀请人"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="70"
        >
          <template slot-scope="scope">{{ scope.row.shareStaffName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="备案药企"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="250"
        >
          <template slot-scope="scope">{{ scope.row.staffTenantNames || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="备案部门"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="250"
        >
          <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="审核原因"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="140"
        >
          <template slot-scope="scope">{{ scope.row.approveSuggest || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="性别"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="50"
        >
          <template slot-scope="scope">{{ getName(scope.row.sex, '性别') }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="证件号码"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.idCode || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="age"
          label="年龄"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="70"
        >
          <template slot-scope="scope">{{ getAgeSexByIdCard(scope.row.idCode, 3) }}</template>
        </el-table-column>
        <el-table-column
          prop="staffLevel"
          label="业务员能力"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="90"
        >
          <template slot-scope="scope">{{ getName(scope.row.staffLevel, '业务员能力分类') }}</template>
        </el-table-column>

        <el-table-column
          prop="taskTotal"
          label="出生日期"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="100"
        >
          <template slot-scope="scope">{{ getAgeSexByIdCard(scope.row.idCode, 1) || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="学历"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="70"
        >
          <template slot-scope="scope">{{ getName(scope.row.education, '学历') }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="毕业院校"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.graduatedFrom || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="专业"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="96"
        >
          <template slot-scope="scope">{{ scope.row.professional || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="工作经历"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="70"
        >
          <template slot-scope="scope">{{ scope.row.hasWorkExperience === 'Y' ? '有':'无'}}</template>
        </el-table-column>
        <el-table-column prop="bank" min-width="180" label="操作" header-align="center" align="center" fixed="right">
          <template slot-scope="scope">
            <div>
              <a v-if="scope.row.approveState === 'Y' && scope.row.isSyncRoster !== 'Y'" class="txt-color" @click="toSyncRoster(scope.row)">{{
                '同步花名册 | '
              }}</a>
              <a class="txt-color" @click="toReview(scope.row)"> 详情 | </a>
              <a class="txt-color" v-if="scope.row.approveState === 'A'" @click="batchAudit(scope.row,false)">{{
                '审核'
              }}</a>
              <a class="txt-color" v-if="scope.row.approveState === 'Y'" @click="batchAudit(scope.row,true)">{{
                '修改级别 | '
              }}</a>
              <a class="txt-color" v-if="scope.row.approveState !== 'A'" @click="revokeAudit(scope.row)">{{
                 '撤回重审'
              }}</a>
              <a class="txt-color" v-if="userinfo.logonUser && userinfo.logonUser === '18771137986'" @click="delCvInfo(scope.row)">{{ ' | 删除' }}</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <!-- table end -->
    <!-- 批量审核弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @open="oepnDialog"
      width="600px"
    >
      <div slot="title" class="dialog-title">
        {{isModifyLevel?'修改级别': isBatch?'批量审核':'审核' }}
      </div>
      <div class="dialogCon">
        <!-- 原因说明 -->
        <div class="dialogCon-describe">
          <div class="col-itms" v-if="!isModifyLevel">
            <div class="title"><span style="color: red;">*</span>审核结果：</div>
            <el-radio-group  class="content-left w300" v-model="audit.approveState">
              <el-radio label="Y">通过</el-radio>
              <el-radio label="R">驳回</el-radio>
            </el-radio-group>
          </div>
          <div class="col-itms"  v-if="isModifyLevel||audit.approveState==='Y'">
            <div class="title">
              <span style="color: red;">*</span>
              业务员能力：
            </div>
            <el-select
              size="mini"
              v-model="audit.staffLevel"
              placeholder="请选择"
               class="w300"
              clearable
              filterable
            >
              <el-option
                v-for="item in getCodeListByKey('业务员能力分类')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
           
          </div>
          <div class="col-itms"  v-if="!isModifyLevel">
            <div class="title">
              <span style="color: red;" v-if="audit.approveState==='R'">*</span>
              审核备注：
            </div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 7 }"
              v-model="audit.checkedIssuesText"
              maxlength="100"
              show-word-limit
              class="w300"
              placeholder="输入通过或驳回理由"
              clearable
            ></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false;audit.staffLevel=''">取 消</el-button>
        <el-button size="small" v-if="!isModifyLevel" type="info" @click="toAuditSubmit">审 核</el-button>
        <el-button size="small" v-if="isModifyLevel" type="info" @click="toChangeLevel">修 改</el-button>

      </span>
    </el-dialog>
  </div>
  
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import { getAgeSexByIdCard } from '@/uilt/tool';
export default {
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      getAgeSexByIdCard,
      userinfo: userinfo,
      showMore: false,
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 200,
      fullscreenLoading: false,
      tableLoading: false,
      tableData: [],
      updateTime: [], // 提交时间
      approveTime: [], // 审核时间
      tenantGuidOption:[],// 药企列表
      organisationList:[],// 药企列表
      page: {
        tenantGuid:'',
        organisationGuid:null,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        keyword: '', //人员/手机号
        approveState: 'A', //审核状态
        sourceType: '', //简历来源
        createStartTime: '',
        createEndTime: '',
        approveStartTime: '',
        approveEndTime: '',
        isSyncRoster:'',
        staffLevelList:[],
      },
      type: {
        A: 'warning',
        Y: 'success',
        R: 'danger',
        N: 'info',
      },
      approveStateObj: {
        A: '待审核',
        Y: '已通过',
        R: '已驳回',
        N: '初始',
      },
      approveStateOp: [
        {
          text: '待审核',
          value: 'A',
        },
        {
          text: '已通过',
          value: 'Y',
        },
        {
          text: '已驳回',
          value: 'R',
        },
      ],
      syncRosterOp: [
        {
          text: '全部',
          value: '',
        },
        {
          text: '已同步',
          value: 'Y',
        },
        {
          text: '未同步',
          value: 'N',
        },
      ],
      multipleSelection:[],//表格多选
      isBatch:false,//是否批量审核
      dialogVisible:false,
      audit:{
        approveState:'',//审核结果
        checkedIssuesText: '',//审核备注
        staffLevel:'',
        idCode:'',
      },
      //是否修改级别
      isModifyLevel:false,
      tabText: [
        { name: '全部', value: '' },
        { name: '待审核', value: 'A' },
        { name: '已通过', value: 'Y' },
        { name: '已驳回', value: 'R' },
      ],
      activeTab:1,
    };
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 315;
        this.contentMainHeight = window.innerHeight - 250;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 260;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  created() {
    this.getList(true);
    this.getDict();
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === '/cvInforReview' || from.path === '/importCvInfor') {
      next((vm) => {
        vm.getList();
      });
    } else {
      next();
    }
  },
  methods: {
    changeTab(index, item) {
      this.page.approveState = item.value;
      this.activeTab = index;
      this.multipleSelection=[]
      this.$refs.multipleTable.clearSelection();
      // this.activeTabItem = item;
      console.log('000',this.page.approveState);
      
      this.getList(true);
      
    },
    //批量导出
    batchExport() {
      let self = this;
      this.page.createStartTime = this.updateTime[0]
        ? this.$moment(this.updateTime[0]).format('YYYY-MM-DD 00:00:00')
        : '';
      this.page.createEndTime = this.updateTime[1]
        ? this.$moment(this.updateTime[1]).format('YYYY-MM-DD 23:59:59')
        : '';
      this.page.approveStartTime = this.approveTime[0]
        ? this.$moment(this.approveTime[0]).format('YYYY-MM-DD 00:00:00')
        : '';
      this.page.approveEndTime = this.approveTime[1]
        ? this.$moment(this.approveTime[1]).format('YYYY-MM-DD 23:59:59')
        : '';
      self.fullscreenLoading = true;
      self.api.postJsonD(`/${serverConfig.msPersonnelService}/staff-resume/data/export`, this.page).then((res) => {
        let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let fileName = '服务人员招募简历信息_' + this.$moment(new Date()).format('YYYYMMDD');
        let objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = fileName;
        link.href = objectUrl;
        link.click();
        self.fullscreenLoading = false;
      });
    },
    batchImport(guid){
      this.$router.push({ path: '/importCvInfor',query:{ productGuid:this.$route.query.productGuid}});
    },
    //批量审核
    batchAudit(row, isModifyLevel) {
      this.isBatch = true
      this.isModifyLevel = isModifyLevel
      this.audit.staffLevel = '';
      if (row) {
        this.isBatch = false
        this.multipleSelection.push(row.guid)
        this.audit.staffLevel = row.staffLevel;
        this.audit.idCode =  row.idCode;
      }
      if (!this.multipleSelection.length & !isModifyLevel) {
        this.$message.error('请勾选数据！');
        return
      }

      this.dialogVisible = true;
    },
    
    // 打开批量审核弹框的钩子
    oepnDialog() {
      this.audit.approveState = '';
      this.audit.checkedIssuesText = '';
    },
    // 提交原因
    toAuditSubmit() {
      if (!this.audit.approveState) {
        this.$message.error('审核结果不能为空');
        return;
      }
      if (!this.audit.staffLevel && this.audit.approveState == 'Y') {
        this.$message.error('业务员能力不能为空！');
        return
      }
      if (this.audit.approveState === 'R' && !this.audit.checkedIssuesText) {
        this.$message.error('请填写理由');
        return;
      }
      this.toAuditRequire()
      
      
    },
    
    // 批量审核接口
    toAuditRequire() {
      let self = this
      let userInfo = JSON.parse(localStorage.userInfo)
      if(!this.multipleSelection.length)return
      let message=this.audit.approveState === 'R' ? '驳回成功' : '审核成功';
      let query={
        approveState: this.audit.approveState,
        approveTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        approveSuggest: this.audit.checkedIssuesText,
        approveStaffGuid: userInfo.staffGuid,
        staffLevel:this.audit.staffLevel,
        guids: this.multipleSelection
      }
      this.tableLoading = true;
      this.api.postJson(`/${serverConfig.msPersonnelService}/staff-resume/data/approve`, query)
        .then((res) => {
          this.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.dialogVisible = false;
            self.$message.success(message);
            self.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        
    },
    //修改级别
    toChangeLevel(){
      if (!this.audit.staffLevel) {
        this.$message.error('业务员能力不能为空！');
        return
      }
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msPersonnelService}/staff-resume/data/update-level?staffLevel=${this.audit.staffLevel}&idCode=${this.audit.idCode}`)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.dialogVisible = false;
            this.$message.success('修改成功');
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        })
    },
    //批量撤回
    revokeAudit(row) {
      
      if(row){
        this.multipleSelection.push(row.guid)
      }
      console.log('this.multipleSelection',row,this.multipleSelection);
      if (!this.multipleSelection.length) {
        this.$message.error('请勾选数据！');
        return
      }
      this.toRevoke()
      
    },
    toRevoke() {
      var self = this;
      self
        .$confirm('撤回后需要重新审核，确定操作吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          var req = this.multipleSelection;
          self.tableLoading = true;
          self.api.postJson(`/${serverConfig.msPersonnelService}/staff-resume/data/approve-revoke`, req).then((res) => {
            self.tableLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('撤回成功');
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    // 批量导入
    batchImport() {
      this.$router.push({
        path: "/importResumeList",
        query: { 
          productGuid: localStorage.productGuid,
        },
      });
    },
    // 表格多选
    handleSelectionChange(val){
      this.multipleSelection = [];
      
      val.forEach((item)=>{
        this.multipleSelection.push(item.guid)
      })
      console.log('vv',this.multipleSelection);
    },
    
    // 获取字典的text
    getName(name, key) {
      let list = this.getCodeListByKey(key);
      let lisArr = list.filter((item) => item.value == name);
      return lisArr.length ? lisArr[0].text : '-';
    },
    emptySearch() {
      this.updateTime = [];
      this.approveTime = [];
      this.organisationList = [];
      this.page = {
        tenantGuid:'',
        organisationGuid:null,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        keyword: '', //人员/手机号
        approveState: this.page.approveState, //审核状态
        sourceType: '', //简历来源
        createStartTime: '',
        createEndTime: '',
        approveStartTime: '',
        approveEndTime: '',
        isSyncRoster:'',
        staffLevel:[],
      };
      this.getList(true);
    },
    getList(flg) {
      let self = this;
      if(flg){
        this.page.pageIndex = 1;
      }
      
      this.page.createStartTime = this.updateTime[0]
        ? this.$moment(this.updateTime[0]).format('YYYY-MM-DD 00:00:00')
        : '';
      this.page.createEndTime = this.updateTime[1]
        ? this.$moment(this.updateTime[1]).format('YYYY-MM-DD 23:59:59')
        : '';
      this.page.approveStartTime = this.approveTime[0]
        ? this.$moment(this.approveTime[0]).format('YYYY-MM-DD 00:00:00')
        : '';
      this.page.approveEndTime = this.approveTime[1]
        ? this.$moment(this.approveTime[1]).format('YYYY-MM-DD 23:59:59')
        : '';
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff-resume/data/get`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.$refs.multipleTable.clearSelection();
          self.$refs.multipleTable.bodyWrapper.scrollTop = 0
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    // 去审核
    toReview(item) {
      this.$router.push({
        path: `/cvInforReview`,
        query: {
          guid: item.guid,
          isAudit:true,
        },
      });
    },
    // 删除简历(开发人员使用)
    delCvInfo(item) {
      let param = [item.guid];
      this.api.postJson(`/${serverConfig.msPersonnelService}/staff-resume/data/delete`, param).then((res) => {
        this.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.success('删除成功');
          this.getList(true);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    async toSyncRoster(data) {
      let res = await this.checkHisUser(data);
      if (!res) {
        // 新用户
        this.$router.push({
          path: '/brokerInsuredEdit',
          query: {
            cvInfoGuid: data.guid,
            approvalState:'Y',
            productGuid: this.$route.query.productGuid
          },
        });
      } else if (res && res[0]) {
        // ! 历史人员为编辑花名册, 花名册有的信息不赋值, 没有的信息赋值
        let item = res[0];
        let cvInfo = {
          name: data.name, // 姓名
          mobileNo: data.mobileNo, // 电话
          professional: data.professional, // 专业
          sex: data.sex, // 性别
          idCode: data.idCode, // 证件号码
          education: data.education, // 学历
          graduatedFrom: data.graduatedFrom, // 毕业学校
        };
        let cvInfoKeyList = Object.keys(cvInfo);
        cvInfoKeyList.forEach((key) => {
          if (!item[key]) item[key] = cvInfo[key];
        });
        // 老用户
        this.$router.push({
          path: '/brokerInsuredDetail',
          query: {
            item: JSON.stringify(item),
            cvInfoGuid: data.guid,
            approvalState:'Y',
            productGuid: this.$route.query.productGuid
          },
        });
      }
    },
    // 判断是否为历史用户
    checkHisUser(item) {
      try {
        return new Promise((resolve, reject) => {
          this.api
            .postJson(`/${serverConfig.msPersonnelService}/staff-roster/list`, { idCode: item.idCode })
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                resolve(res.data.data.records);
              } else {
                this.$message.error('请稍后重试');
              }
            });
        });
      } catch (error) {}
    },
    //运营获取药企
    getDict() {
      let self = this;
      self.powerTenantNames = [];
      let query={
        pageIndex: 1,
        pageSize: -1,
        memberStatus:'ZSHY'
        // queryAllServiceTenantFlag: false, // 是否查询所有的运营公司 true是 false否
        // currentTenantGuid: localStorage.guid,
      }
      self.api
        .postJson(
          `/${serverConfig.msCustomerService}/tenant/data/get-simple-tenants`,
          query
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantGuidOption = res.data.data.records? res.data.data.records : [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    handleChangeCompany(v) {
      let self = this;
      self.page.organisationGuis = null;
      self.organisationList = []
      if(!v)return
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
/deep/ .el-dialog__body{
  padding:0;
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.el-col-6 {
  margin-bottom: 8px;
  display: flex;
}
.ipt-sty {
  flex: 1;
}
.search-area-div{
    flex-shrink: 0;
    margin-right: 4px;
    text-align:right;
    width: 84px;
  }
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.management-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}

.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}

.management-name {
  flex-shrink: 0;
}

.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}

.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}

.input-item .input-title {
  margin-right: 14px;
}

.add {
  text-align: left;
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}

.del {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}

.product-item {
  display: flex;
  margin-top: 10px;
}

.product {
  display: flex;
  align-items: center;
}

.product-img {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}

.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reject-btn.btn {
  background: #fff2f4;
  border: 1px solid rgba(255, 219, 224, 1);
  border-radius: 2px;
  color: #fb2323;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.pass-btn.btn {
  background: #f2fff5;
  border: 1px solid rgba(220, 250, 228, 1);
  border-radius: 2px;
  color: #1ba854;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ing-btn.btn {
  background: #fffbf2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: #ff991c;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.cancel-btn.btn {
  background: #f5f5f5;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  color: #666;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}
.dialogCon-describe .col-itms {
  display: flex;
  align-items: baseline;
  margin-left: 20px;
  margin-bottom: 10px;
}
.dialogCon-describe .col-itms .title {
  width: 120px;
  text-align: right;
  margin-right: 16px;
}
.dialogCon {
  /* border-top: 1px solid #dcdee0; */
  text-align: left;
  /* padding: 10px 20px; */
}
.dialog-title {
  text-align: left;
  width: 100%;
  height: 27px;
  font-family: PingFang SC;
  font-size: 18px;
  color: #212121;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 400;
}
.searchHead {
    height: 40px;
    color: #9d9d9d;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 6px;
    margin-bottom: 8px;
    background: #fff;
  }
  .searchHead-left {
    display: flex;
  }
  .searchHead .tab {
    margin: 0 13px;
    cursor: pointer;
    position: relative;
  }
  .searchHead .active {
    color: #232323;
  }
  .searchHead .active .line {
    width: 80%;
    height: 3px;
    background: #4fa1a4;
    margin-top: 4px;
    position: absolute;
    left: 10%;
  }
  .searchHead .active1 .line1 {
    width: 100%;
    height: 3px;
    background: #4fa1a4;
    margin-top: 4px;
    position: absolute;
    left: 0;
    top: 0;
  }
</style>
